module.exports = __webpack_public_path__ + "static/media/ts12tj1023.2423f59b.png";